import countryAgnosticValidateSsn from './validateSsn';
var SSN_REGEX = '^\\d{3}-\\d{2}-\\d{4}$';
var ssnRegexGenerator = function (strict) {
    if (strict === void 0) { strict = true; }
    return (strict ? new RegExp("^".concat(SSN_REGEX, "$")) : new RegExp(SSN_REGEX));
};
export var ssnRegex = ssnRegexGenerator();
export var ssnRegexExtract = ssnRegexGenerator(false);
export var validateSsn = function (ssn) {
    return countryAgnosticValidateSsn({
        ssnRegex: ssnRegexGenerator(),
        computeSsnControlKey: computeSsnControlKey,
        extractSsnControlKey: extractSsnControlKey,
    }, ssn);
};
/** US hasn't any control key */
export function computeSsnControlKey() {
    return '';
}
/** US hasn't any control key */
export function extractSsnControlKey() {
    return '';
}
